module.exports = __webpack_public_path__ + "static/media/timer-yellow.485bd62b.svg";